import React from 'react';
import { createUseStyles } from 'react-jss';
import { IonText } from '@ionic/react';
import { Card } from '../../components/Card';
import { CardHeading } from '../components/CardHeading';
import { CheckinIcon } from '../components/CheckinIcon';
import { CheckinDetailsConfig, ICheckinDetailsType, typeToKey } from '../model/CheckinDetailsConfig';
import { ICheckin, ICheckinTag } from '../model/ICheckin';

const useStyles = createUseStyles({
    icons: {
        marginTop: 18,
        display: 'grid',
        gridRowGap: 28,
        justifyItems: 'center',
        gridTemplateColumns: 'repeat(4, 1fr)'
    }
});

interface IFrequencyCardProps {
    type: ICheckinDetailsType;
    title: string;
    checkins: ICheckin[];
    'data-id'?: string;
};

export const FrequencyCard: React.FC<IFrequencyCardProps> = ({ type, title, checkins, 'data-id': dataId })  => {
    const classes = useStyles();

    const config = CheckinDetailsConfig[type];

    const values: {[key: string]: number} = {};
    for (const c of checkins as any[]) {
        const key = typeToKey[type];
        const tags: ICheckinTag[] = c[key] || [];
        for (const t of tags) {
            values[t] = (values[t] || 0) + 1;
        }
    }

    return (
        <Card dataProps={{dataId}} padded>
            <CardHeading>{title}</CardHeading>
            <div className={classes.icons}>
                {config.icons.map(icon => {
                    const value = ((values as any)[icon.label] || 0);
                    const active = (value > 0);
                    return (
                        <div data-type="freq-item" key={icon.label} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <CheckinIcon
                                data-type="item-icon"
                                key={icon.label}
                                data-id={icon.label}
                                Icon={icon.Icon}
                                label={icon.label}
                                active={active}
                                activeColor={icon.activeColor}
                            />
                            <IonText
                                data-type="item-count"
                                style={{margin: '3px 0', fontWeight: 'bold'}}
                                color={!active ? 'medium' : undefined}
                            >
                                {value}
                            </IonText>
                        </div>
                    );
                })}
            </div>
        </Card>
    );
};
